export const fillOpacityWithCallback = (
  opacity: number,
  selectedOpacity: number
) => [
  "case",
  ["boolean", ["feature-state", "hover"], ["feature-state", "selected"], false],
  selectedOpacity,
  opacity,
];
